<div class="select-item-drag-preview float-left">
    {{ draggedElementsCount }}
</div>
@for (preview of dragContext.previews; track $index) {
    <div>
        {{ preview }}
    </div>
}
